import React, { useEffect, useState } from "react";
import style from "./privillages.module.scss";
import Button from "../../Button/button"
import Modal from "../../Modal/Modal";
import Input from "../../input/input"
import Dropdown from "../../Dropdown/ThreeDotsDropDown/DropDown";
import { Privillages } from "../../../helpers/consts/usersprivillages"
import Checkbox from "../../SelectionControls/Checkbox/Checkbox"
import Toast from "../../Toast/Toast"
import toPersianNumber from "../../../helpers/actions/toPersianNumber";
import { withRouter, Link } from "react-router-dom";
import { AddPermission, DeletePermission, EditPermission, GetPermissionList } from "../../../actions/APIcalls"
import ExpiredAccountWarning from "../../expiredAccountWarning/expiredAccountWarning"
import GradientToast from "../../gradientToast/Toast"
import DownGradeWarning from "../../downGradeWarning/downGradeWarning";
import Skeleton from "./skeleton"

const Permissions = (props) => {
    const [hasSkeleton, setHasSkeleton] = useState(false)
    const [addPrivillage, setAddPrivillage] = useState({ open: false, title: "", err: "" })
    const [editPrivillage, setEditPrivillage] = useState({ open: false, id: "", success: false, title: "" })
    const [deletePrivillage, setDeletePrivillage] = useState({
        open: false,
        id: "",
        success: false,
        userCount: 0,
        title: ""
    })
    const [privillageToggle, setPrivillageToggle] = useState({})
    const [privillageOpen, setPrivillageOpen] = useState({})
    const [permissionList, setPermissionList] = useState([])
    const [toast, setToast] = useState('')
    //lifeCycles********************************************************************************************
    useEffect(() => {
        setInitialPermission()
        getPermissionList();
    }, [])
    //functions*********************************************************************************************
    const doNothing = () => {

    }
    const setInitialPermission = () => {
        let obj = {};
        let obj2 = {}
        renderLayers(0).forEach((item, index) => {
            obj[item.value] = false;
            obj2[item.value] = ""
        })
        setPrivillageOpen(obj)
        setPrivillageToggle(obj2)
    }
    //get data**********************************************************************************************
    const getPermissionList = async () => {
        setHasSkeleton(true)
        let res = await GetPermissionList()
        if (res && res.data) {
            // console.log(res, "list");

            setPermissionList([...res.data.permissionList])
            // console.log(permissionList);
        }
        setHasSkeleton(false)
    }
    //handelers*********************************************************************************************
    const addPrivillageHandler = async () => {
        if (addPrivillage.title) {
            let params = { title: addPrivillage.title, permission: { ...privillageToggle } }
            let res = await AddPermission(params)
            console.log(res, 'res res');
            if (res && res.data && res.data.success) {
                setAddPrivillage({ open: false, err: "" })
                setPrivillageToggle({})
                setPrivillageOpen({})
                getPermissionList()
            } else if (typeof res !== "undefined" && typeof res.response !== "undefined") {
                console.log("here9");
                setToast(res.response.data.error)
            }
        } else {
            let priv = addPrivillage
            priv.err = "تکمیل این فیلد الزامیست!"
            setAddPrivillage({ ...priv })
        }
    }
    const editPrivillageHandler = async () => {
        let perm = { ...privillageToggle }
        perm.title = editPrivillage.title
        let params = { permission: { ...perm }, permissionId: editPrivillage.id }
        let res = await EditPermission(params)
        if (res && res.data && res.data.success) {
            setEditPrivillage({ open: false })
            setPrivillageToggle({})
            setPrivillageOpen({})
            getPermissionList()
        }
    }
    const deletePrivillageHandler = async () => {
        // let params = { permissionId: deletePrivillage.id }
        // let res = await CheckDeletePermission(params) 
        // console.log(res,'yoho');
        // if ( typeof res !== "undefined" && res.status === 400) {
        //     let deletep = deletePrivillage
        //     deletep.userCount =res.data.error
        //     setDeletePrivillage({...deletep})
        // }
        let params = { permissionId: deletePrivillage.id }
        let res = await DeletePermission(params)
        if (typeof res !== "undefined" && typeof res.data !== "undefined") {
            let dlt = deletePrivillage
            dlt.success = true;
            setDeletePrivillage({ ...dlt })
            getPermissionList()
        } else if (typeof res !== "undefined" && typeof res.response !== "undefined") {
            let deletep = deletePrivillage
            deletep.userCount = res.response.data.error
            setDeletePrivillage({ ...deletep })
        }

    }
    const editPrivillages = (tag, item) => {
        if (tag === "edit") {
            if (typeof props.user !== "undefined" && props.user.permission.userManagement.includes("Edit")) {

                // console.log(item, "item");
                let edit = editPrivillage;
                edit.open = true;
                edit.id = item._id;
                edit.title = item.title
                let permission = {}
                Object.keys(item).forEach(i => {
                    if (i !== "title") {
                        permission[i] = item[i]
                    }

                })
                setEditPrivillage({ ...edit })
                setPrivillageToggle({ ...permission })
            }
        }

        if (tag === "delete") {
            if (typeof props.user !== "undefined" && props.user.permission.userManagement.includes("Delete")) {

                // console.log(item, "item");
                let deleteP = deletePrivillage;
                deleteP.open = true;
                deleteP.id = item._id;
                deleteP.title = item.title
                setDeletePrivillage({ ...deleteP })
            }
        }
    }

    const onchangeHandler = (tag, value, secondTag) => {
        let addPre = addPrivillage
        let edit = editPrivillage
        switch (tag) {
            case "addPrivillageTitle": {
                addPre.title = value.target.value;
                setAddPrivillage({ ...addPre })
                break;
            }
            case "editPrivillageTitle": {
                edit.title = value.target.value;
                setEditPrivillage({ ...edit })
                break;
            }
            default:
                break;
        }

    }

    const onBlureHandler = (tag) => {
        let addPre = addPrivillage
        switch (tag) {

            case "addPrivillageTitle": {
                if (addPrivillage.title.length === 0) {
                    addPre.err = "تکمیل این فیلد الزامی است!"
                } else {
                    addPre.err = ""
                }
                setAddPrivillage({ ...addPre })
                break;
            }

            default:
                break;
        }

    }

    const cancelModal = (tag, get, set) => {
        if (tag === "deletePrivillage") {
            set({ open: false });

        } else {
            let modal = get;
            modal.id = "";
            modal.channelId = "";
            modal.open = false;
            modal.success = false;
            modal.title = ""
            setPrivillageToggle({})
            if (tag === "addPrivillage") {
                setInitialPermission()
                modal.title = ""
            }
            console.log(modal);
            set({ ...modal });
        }

    }
    const CheckBoxHandler = (e, value, tag, inputPermission) => {
        console.log(e, value, tag, inputPermission);
        let state = { ...privillageToggle };
        let permission = { ...inputPermission };
        // console.log(permission,value);
        if (!value) {
            let temp = permission.check.split(/(?=[A-Z])/)
            temp.forEach(item => {
                if (!state[tag].includes(permission.check)) {
                    console.log("hi");
                    state[tag] = state[tag].concat(item);
                }
            })
        } else {
            let temp = permission.uncheck.split(/(?=[A-Z])/)
            let helper = state[tag];
            temp.forEach(item => {
                console.log(item);
                let res = helper.replace(item, '')
                console.log(res);
                helper = res;
            });
            state[tag] = helper;
        }
        setPrivillageToggle({ ...state })
        console.log(privillageToggle);
    }
    const isChecked = (permission, itemPermission) => {
        let result = false
        if (itemPermission) {
            let temp = itemPermission.split('')
            temp.forEach(char => {
                if (!permission.includes(char)) {
                    result = true
                }
            }
            )
        }
        if (result) {
            return false
        } else {
            return true
        }
    }
    //JSX*****************************************************************************************************************
    const renderLayers = (pId) => {
        return Privillages.filter(item => item.parentId === pId.toString());
    }
    const renderCard = (item, index) => {
        return (
            <div className={style.cardContainer} key={index}>
                <div className={style.card}>
                    <div className={style.pack}>
                        <div className={style.buttonWrap}>
                            <Dropdown
                                items={[{
                                    name: "ویرایش ", onclick: () => {
                                        editPrivillages("edit", item)
                                    }, modalOpen: () => {
                                    }
                                },
                                {
                                    name: "حذف", onclick: () => {
                                        editPrivillages("delete", item)
                                    }, modalOpen: () => {
                                    }
                                }]}
                            />
                        </div>
                        <p>{toPersianNumber(item.title)}</p>
                    </div>
                </div>
                {index % 2 === 0 || index === 0 ? <div className={style.space}></div> : null}
            </div>
        )
    }
    const ButtonPackRenderer = (maintag, canceltag, mainlabel, mainaction, get, set) => {
        return (
            <div className={style.buttonPack}>
                < Button
                    disabled={false}
                    tag={canceltag}
                    type="outline"
                    label="انصراف"
                    onclick={() => {
                        cancelModal(maintag, get, set);
                        setToast('')
                    }} />
                <div className={style.splitter}></div>
                < Button
                    disabled={false}
                    tag={maintag}
                    type="solid"
                    label={mainlabel}
                    onclick={() => mainaction()}
                />
            </div>
        )
    }


    const modalActivator = (modalName) => {
        switch (modalName) {
            case "addPrivillage":
                if (typeof props.user !== "undefined" && props.user.permission.userManagement.includes("Permission")) {
                    {
                        let add = addPrivillage;
                        add.open = true;
                        setAddPrivillage({ ...add });

                    }
                    break
                }
            default:
                break;
        }
    }
    const privillageRenderer = () => {
        // console.log(toast.length,"iii");
        return (
            <div>


                {renderLayers(0).map((item, index) => {
                    // console.log(privillageToggle[item.value],item.permisson,"hi");
                    return (
                        <div key={index}>
                            <div className={style.privillageWrapper}>
                                <div className={style.openIcon}
                                    onClick={e => {
                                        let state = { ...privillageOpen };
                                        // console.log(privillageOpen[item.value],"val");
                                        state[item.value] = !privillageOpen[item.value];
                                        setPrivillageOpen({ ...state })
                                    }}>
                                    <p>m</p>
                                </div>
                                <Checkbox
                                    // value={privillageToggle[item.value] && privillageToggle[item.value].includes(item.permisson) ? true : false}
                                    value={privillageToggle[item.value] && isChecked(privillageToggle[item.value], item.check) ? true : false}
                                    indeterminate={false}
                                    disabled={false}
                                    tag={item.value}
                                    secondTag={item}
                                    label=''
                                    onclick={CheckBoxHandler}

                                />

                                <div className={style.headerTitles}>{item.title}</div>
                            </div>
                            {privillageOpen[item.value] ? renderLayers(item.id).map((element, indx) => {
                                //    console.log(privillageToggle[item.value],element.permisson,"bye");
                                return <div className={style.container} key={indx}>
                                    <div className={style.privillageWrapper}>
                                        <Checkbox
                                            value={privillageToggle[item.value] && isChecked(privillageToggle[item.value], element.check) ? true : false}
                                            // value={privillageToggle[item.value] && privillageToggle[item.value].includes(element.permisson) ? true : false}
                                            indeterminate={false}
                                            disabled={false}
                                            tag={item.value}
                                            secondTag={element}
                                            label=''
                                            onclick={CheckBoxHandler}
                                        />
                                        <div className={style.headerTitles}>{element.title}</div>
                                    </div>
                                </div>

                            }
                            ) : null}

                        </div>
                    )

                })}
            </div>
        )
    }

    if (hasSkeleton) {
        return <Skeleton />
    } else {
        return (
            <div className={style.wrapper}>
                {
                    props.user.expiredAccount &&
                    <div className={style.gradientWrapper}>
                        <GradientToast tag="test" value={true}>
                            <>
                                <p className={style.expiredTitle}>شارژ کیف پول شما تمام شده‌است.</p>
                                <p className={style.expiredText}>برای فعال‌سازی مجدد ربات، کیف پول خود را شارژ کنید.</p>
                                <Link className={style.expiredLink} to={'/chargewallet'}>ورود به صفحه‌ی  شارژ کیف پول  </Link>
                            </>
                        </GradientToast>
                    </div>
                }
                {/* {
                    Object.keys(props.user.downGradeWarning).length !== 0 &&
                    <div className={style.gradientWrapper}>
                        <GradientToast tag="test" value={true}>
                            <>
                                <DownGradeWarning data={{ ...props.user.downGradeWarning }} />
                            </>
                        </GradientToast>
                    </div>
                } */}
                <Toast
                    tag='Toast_1'
                    text={toast}
                    value={typeof toast !== "undefined" && toast.length > 0 ? true : false}
                    parentClose={() => {
                        setToast("")
                    }}
                />
                <Modal
                    tag="deletePrivillage"
                    value={deletePrivillage.open ? true : false}
                    title="حذف سطح دسترسی"
                    parentClose={() => {
                        setDeletePrivillage({ open: false });
                        setToast('')
                    }}>
                    <div className={style.modalContent}>
                        {/* {console.log(deletePrivillage)} */}
                        {deletePrivillage.success ?
                            <div>
                                <p className={style.deleteText}>.سطح دسترسی مورد نظر با موفقیت حذف شد</p>
                                <Button type="solid" label='تایید' onclick={() => {
                                    setDeletePrivillage({ open: false })
                                }} />
                            </div>
                            : (
                                deletePrivillage.userCount > 0 ?
                                    <div>
                                        <p>
                                            .شما
                                            {" "}{toPersianNumber(deletePrivillage.userCount)}{" "}
                                            کاربر با سطح دسترسی
                                            {" "} {deletePrivillage.title}{" "}
                                            دارید
                                        </p>
                                        <p>.لطفا ابتدا سطح دسترسی این کاربران را تغییر دهید</p>
                                        {ButtonPackRenderer("deletePrivillage", "canceldeletePrivillage", "مشاهده کاربران", () => {
                                            props.history.push(
                                                '/users?search=' + deletePrivillage.id,
                                                { id: deletePrivillage.id }
                                            );
                                        }, deletePrivillage, setDeletePrivillage)}
                                    </div>
                                    :
                                    <div>
                                        <p className={style.deleteText}>
                                            آیا از حذف
                                            {" "}{deletePrivillage.title} {" "}
                                            اطمینان دارید؟</p>
                                        {ButtonPackRenderer("deletePrivillage", "canceldeletePrivillage", "حذف", () => {
                                            deletePrivillageHandler()
                                        }, deletePrivillage, setDeletePrivillage)}
                                    </div>
                            )
                        }
                    </div>
                </Modal>
                <Modal
                    tag="newPrivillage"
                    value={addPrivillage.open ? true : false}
                    title="سطح دسترسی جدید"
                    parentClose={() => {
                        setAddPrivillage({ open: false });
                        setToast('')
                    }}>
                    <div className={style.modalContent}>
                        <Input
                            label="عنوان"
                            placeholder="عنوان"
                            tag="addPrivillageTitle"
                            value={addPrivillage.title}
                            error={addPrivillage.err}
                            tooltip={""}
                            onchange={onchangeHandler}
                            onblur={onBlureHandler} />
                        <h6>سطح دسترسی</h6>
                        {privillageRenderer()}
                        {ButtonPackRenderer("addPrivillage", "cancelPrivillage", "ایجاد", addPrivillageHandler, addPrivillage, setAddPrivillage)}

                    </div>
                </Modal>
                <Modal
                    tag="editPrivillage"
                    value={editPrivillage.open ? true : false}
                    title="ویرایش سطح دسترسی "
                    parentClose={() => {
                        setEditPrivillage({ open: false });
                        setInitialPermission();
                        setToast('')
                    }}>
                    <div className={style.modalContent}>
                        <Input
                            label="عنوان"
                            placeholder="عنوان"
                            tag="editPrivillageTitle"
                            value={editPrivillage.title}
                            error={editPrivillage.err}
                            tooltip={""}
                            onchange={onchangeHandler}
                            onblur={onBlureHandler} />
                        <h6>سطح دسترسی</h6>
                        {privillageRenderer()}
                        {ButtonPackRenderer("editPrivillage", "cancelPrivillage", "ویرایش", editPrivillageHandler, editPrivillage, setEditPrivillage)}
                    </div>
                </Modal>
                <div className={style.header}>
                    <h1>سطح دسترسی </h1>
                    <div className={style.buttonsWrapper}>
                        <Button label="سطح دسترسی جدید" type="solid" tag="addPrivillage" disabled={false}
                            onclick={modalActivator} />
                    </div>
                </div>
                {/* {
                props.user.expiredAccount &&
                <ExpiredAccountWarning/>
            }
            {
                Object.keys(props.user.downGradeWarning).length !== 0 &&
                <DownGradeWarning data={{...props.user.downGradeWarning}}/>
            } */}
                {/* <div className={style.searchbarWrapper}> */}
                {/* <Searchbar placeholder="نام و نام خانوادگی یا شماره موبایل" /> */}
                {/* </div> */}

                {permissionList.length > 0 ? <div className={style.cardWrapper}>
                    {
                        permissionList.map((item, index) => {
                            return renderCard(item, index)
                        })
                    }
                </div> :
                    <div className={style.empty}>
                        <div className={style.icon}>
                            Q
                        </div>
                        <p>.کاربر عزیز، در حال حاضر شما هیچ سطح دسترسی در ربات موبیشا ندارید</p>
                        <div className={style.buttonsWrapper}>
                            <div className={style.addUser}>
                                <Button label="سطح دسترسی جدید" type="solid" tag="addPrivillage" disabled={false}
                                    onclick={modalActivator} />
                            </div>
                        </div>
                    </div>}
            </div>
        )
    }
}

export default withRouter(Permissions);
